import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';
import './Campeonatos.css';

function Campeonatos() {
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userRole');
  const [campeonatos, setCampeonatos] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCampeonatos = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('Você precisa estar logado para acessar os campeonatos.');
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${API_BASE_URL}/wp-json/palpitex/v1/campeonatos`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = Array.isArray(response.data) ? response.data : [];
        setCampeonatos(data);
        setError(null);
      } catch (error) {
        console.error('Erro na requisição:', error);
        // Log adicional para depuração
        console.log('Resposta do erro:', error.response?.data);
        setError(error.response?.data?.message || 'Erro ao carregar campeonatos.');
        setCampeonatos([]); // Garante que campeonatos seja sempre um array
      } finally {
        setLoading(false);
      }
    };

    fetchCampeonatos();
  }, []);

  const handleAddCampeonato = () => {
    navigate('/add-campeonato');
  };

  const handleCampeonatoClick = (campeonatoId) => {
    navigate(`/predictions/${campeonatoId}`);
  };

  return (
    <div className="campeonatos-container">
      <div className="campeonatos-header">
        <h2>Campeonatos</h2>
        {userRole === 'administrator' && (
          <button className="add-button" onClick={handleAddCampeonato}>
            +
          </button>
        )}
      </div>
      {loading && <p>Carregando campeonatos...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && Array.isArray(campeonatos) && campeonatos.length > 0 ? (
        <div className="campeonatos-list">
          {campeonatos.map((campeonato) => (
            <div
              key={campeonato.id}
              className="campeonato-item"
              onClick={() => handleCampeonatoClick(campeonato.id)}
            >
              <img src={campeonato.logo} alt={campeonato.nome} className="campeonato-logo" />
              <div className="campeonato-info">
                <h3>{campeonato.nome}</h3>
                <p>Ano: {campeonato.ano}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        !loading && !error && <p>Não há campeonatos cadastrados.</p>
      )}
    </div>
  );
}

export default Campeonatos;